import { render, staticRenderFns } from "./OFormFieldLayout.vue?vue&type=template&id=bc85d98a&scoped=true"
import script from "./OFormFieldLayout.vue?vue&type=script&lang=js"
export * from "./OFormFieldLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc85d98a",
  null
  
)

export default component.exports